// extracted by mini-css-extract-plugin
export default {"container":"SideTitle_container__oEhM7","left":"SideTitle_left__9gEda","support":"SideTitle_support__ccgwy","text":"SideTitle_text__akZbO","arrowIcon":"SideTitle_arrowIcon__HnPjl"};